export const zhipuaiModels = {
    id: "zhipuai",
    name: "Zhipu AI",
    api: "https://open.bigmodel.cn/api/paas/v4",
    npm: "@ai-sdk/openai-compatible",
    doc: "https://docs.z.ai/guides/overview/pricing",
    env: ["ZHIPU_API_KEY"],
    models: {
        "glm-4.5": {
            id: "glm-4.5",
            name: "GLM-4.5",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 2.2,
                cache_read: 0.11,
                cache_write: 0,
            },
            limit: {
                context: 131072,
                output: 98304,
            },
        },
        "glm-4.5-flash": {
            id: "glm-4.5-flash",
            name: "GLM-4.5-Flash",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0,
                output: 0,
                cache_read: 0,
                cache_write: 0,
            },
            limit: {
                context: 131072,
                output: 98304,
            },
        },
        "glm-4.5v": {
            id: "glm-4.5v",
            name: "GLM 4.5V",
            attachment: true,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-08-11",
            last_updated: "2025-08-11",
            modalities: {
                input: ["text", "image", "video"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.6,
                output: 1.8,
            },
            limit: {
                context: 64000,
                output: 16384,
            },
        },
        "glm-4.5-air": {
            id: "glm-4.5-air",
            name: "GLM-4.5-Air",
            attachment: false,
            reasoning: true,
            temperature: true,
            tool_call: true,
            knowledge: "2025-04",
            release_date: "2025-07-28",
            last_updated: "2025-07-28",
            modalities: {
                input: ["text"],
                output: ["text"],
            },
            open_weights: true,
            cost: {
                input: 0.2,
                output: 1.1,
                cache_read: 0.03,
                cache_write: 0,
            },
            limit: {
                context: 131072,
                output: 98304,
            },
        },
    },
};
export default zhipuaiModels;
//# sourceMappingURL=zhipuai.js.map